import {isPendingStatus} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {ForYouItem} from '../shared/ForYouItem'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'
import {ChecksSection} from './shared/ChecksSection'
import {useValidatedChecksData} from './use-validated-checks-data'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'

// Renders when any checks are pending or needs workflow approval
// It will show all check states - the equivalent in the full mergebox when any checks are pending
export function PendingChecks() {
  const data = useValidatedChecksData()

  if (!data) {
    return null
  }

  const {mergeBoxPullRequest, statusChecks, statusRollup, checksSection} = data
  const shouldRender = checksSection.shouldRender // handles checks count + pending approval
  const hasPendingChecks = statusRollup.summary.some(check => isPendingStatus(check.state))

  if (!shouldRender || !hasPendingChecks) {
    return null
  }

  //TODO - need to follow up and add support for workflow approvals

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="pending-checks"
      padding="none"
      description={accessibleChecksSummary(statusRollup.summary)}
    >
      <ChecksSection
        statusChecks={statusChecks}
        mergeBoxPullRequest={mergeBoxPullRequest}
        statusRollup={statusRollup}
      />
    </ForYouItem>
  )
}
